import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Card, Box } from "@mui/material";
import FullPageLayout from "../../components/FullPageLayout";
import AnnouncementForm from "./AnnouncementForm";
import withStyles from "@mui/styles/withStyles";
import {
  root as learningCenterRoot,
  announcements as learningCenterAnnouncementsRoute
} from "../../routes/LearningCenterRoutes";
import { announcements as adminConsoleAnnouncementsRoute } from "../../routes/AdminRoutes";

const styles = theme => ({
  card: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(5)
  }
});

class AnnouncementsNew extends Component {
  gotoManagement = () => {
    const { history, location } = this.props;
    const announcementsRoute = location.pathname.startsWith(learningCenterRoot)
      ? learningCenterAnnouncementsRoute
      : adminConsoleAnnouncementsRoute;
    history.push(announcementsRoute);
  };

  render() {
    const { classes } = this.props;
    const title =
      this.props.announcement.id > 0
        ? "Manage Announcement"
        : "Create New Announcement";

    return (
      <FullPageLayout title={<Box fontWeight="fontWeightRegular">{title}</Box>}>
        <Card classes={{ root: classes.card }}>
          <AnnouncementForm
            onCancel={this.gotoManagement}
            afterSubmit={this.gotoManagement}
          />
        </Card>
      </FullPageLayout>
    );
  }
}
const mapStateToProps = state => ({
  announcement: state.announcementsState.announcement,
  uploaded: state.announcementsState.uploaded
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(AnnouncementsNew);
